import { WorkspaceUrbanAirshipSettingsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/urban_airship')({
  component: WorkspaceUrbanAirshipSettingsRoute,
});
